export default {

    init() {
        console.log('init nav...');
        document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
    	var menuTimer;
		$('li.wp-block-navigation-item.mega-menu').on('mouseover', function(){
			Nav.closeAllDropdowns();
			clearTimeout(menuTimer);
			$(this).addClass('hovered').closest('header.wp-block-template-part').addClass('mega-menu-on');
			Nav.navClickOutside();
		}).on('mouseout', function(){
			var el = $(this);
			menuTimer = setTimeout(function(){
				el.removeClass('hovered').closest('header.wp-block-template-part').removeClass('mega-menu-on');
			}, 300);
		});

		window.addEventListener('resize', Nav.navState, false);
		//window.addEventListener('scroll', Nav.navScroll, false);
    },

	closeAllDropdowns() {
		$('li.wp-block-navigation-item.mega-menu').each(function() {
			var el = $(this);
			el.removeClass('hovered').closest('header.wp-block-template-part').removeClass('mega-menu-on');
		});
	},

	closeMobileNav() {
		document.querySelectorAll('.wp-block-navigation__responsive-container.has-modal-open').forEach(menuContainer => {
			if(!menuContainer) {
				console.log('false');
				return
			}
			console.log(menuContainer);
			document.querySelector('html').classList.remove('has-modal-open');
			document.querySelector('body').style.overflow = null;
			menuContainer.classList.remove('has-modal-open');
			menuContainer.setAttribute('aria-hidden', 'true');
		});
	},

	navClickOutside() {
		$('nav.wp-block-navigation.is-responsive').on('click.nav', function(e) {
			e.stopPropagation();
		});
  
		$(window).on('click.nav', function(e) {
			Nav.closeAllDropdowns();
			// Remove listeners
			$(window).off('click.nav')
			$('nav.wp-block-navigation.is-responsive').off('click.nav');
		});
	},

	navState() {
		if(Common.isMobile()) {
			Nav.closeAllDropdowns();
		} else {
			Nav.closeMobileNav();
		}	
	},

	navScroll() {
		/* @todo */
	}
}